<script lang="ts" context="module">
  import dayjs from 'dayjs';

  export function publishedDaysAgoFrom(publicationDate: string) {
    const now = dayjs();
    const date = dayjs(publicationDate);

    return now.diff(date, 'days');
  }
</script>

<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  export let publishedDaysAgo: number;

  let label: string;

  $: if (publishedDaysAgo === 0) {
    label = 'Posted today';
  } else if (publishedDaysAgo === 1) {
    label = 'Posted yesterday';
  } else {
    label = `Posted ${publishedDaysAgo} days ago`;
  }

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(14, 14))
    .toCSS();

  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);
</script>

{#if brandReskinEnabled}
  <p>
    <FontSizeDecorator size="caption">
      {label}
    </FontSizeDecorator>
  </p>
{:else}
  <p class={responsiveVars} data-testid="job-publication-date">{label}</p>
{/if}

<style>
  p {
    color: white;
    font-family: var(--font-family-primary);
    font-size: var(--font-size);
    font-weight: 500;
    line-height: 120%;
  }
</style>
